export default __webpack_public_path__ + "assets/innerbanner.b03cb4bd.jpg";